import * as React from "react";
const SvgHeading01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8 2.965a1.035 1.035 0 0 1 0 2.07h-.965v5.93h9.93v-5.93H16a1.035 1.035 0 0 1 0-2.07h4a1.035 1.035 0 0 1 0 2.07h-.965v13.93H20a1.035 1.035 0 0 1 0 2.07h-4a1.035 1.035 0 0 1 0-2.07h.965v-5.93h-9.93v5.93H8a1.035 1.035 0 0 1 0 2.07H4a1.035 1.035 0 0 1 0-2.07h.965V5.035H4a1.035 1.035 0 0 1 0-2.07z"
}));
export default SvgHeading01;
//# sourceMappingURL=Heading01.js.map